import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { Margin } from 'recharts/types/util/types';

import { getNumberFormatter } from '@/utils/getNumberFormatter';

import type { ChartData } from '../types/chart';
import { TickLabel } from './tick-label';
import { TooltipContent } from './tooltip-content';

export const HouseHoldStructureCharts = ({
  chartData,
  height,
  fontSize,
  margin,
}: {
  chartData: ChartData;
  height: number;
  fontSize?: number;
  margin?: Margin;
}) => {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart layout="horizontal" data={chartData} margin={margin}>
        <XAxis
          type="category"
          dataKey="title"
          axisLine={false}
          tickLine={false}
          interval={0}
          tick={({ x, y, payload }) => (
            <TickLabel x={x} y={y + 14} fontSize={fontSize} value={payload.value} />
          )}
        />
        <YAxis
          type="number"
          domain={[0, 50]}
          axisLine={false}
          tickLine={false}
          interval={0}
          tick={({ x, y, payload }) => (
            <TickLabel
              x={x - 10}
              y={y + 5}
              textAnchor="end"
              fontSize={fontSize}
              value={`${payload.value}%`}
            />
          )}
        />
        <CartesianGrid vertical={false} strokeWidth={1} strokeDasharray={4} />
        <Tooltip
          cursor={false}
          content={({ active, payload }) => (
            <TooltipContent active={active} payload={payload}>
              {(item) => (
                <div className="mt-1">
                  <p className="text-[16px] font-normal">
                    {getNumberFormatter(Number(item.absoluteValue), 'en-GB', {
                      maximumFractionDigits: 0,
                      minimumFractionDigits: 0,
                    })}
                  </p>
                  <p className="text-[16px] font-normal">{item.value.toFixed(2)}%</p>
                </div>
              )}
            </TooltipContent>
          )}
        />
        <Bar
          dataKey="value"
          fill="#A0A0A0"
          radius={8}
          activeBar={{
            fill: 'hsl(var(--chart-6))',
          }}
          isAnimationActive={false}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};
